import { useParams } from "react-router-dom";
import EntryRacikanForm from "./EntryRacikanForm";

const UbahEntryRacikan = () => {
  const { id } = useParams();
  return <EntryRacikanForm editId={id} />;
};

export default UbahEntryRacikan;
